/**
 * Computes the visibility state for cart sheet panels and their inner progress indicators.
 *
 * @param {Object} options
 * @param {number}  options.groceryItemsTotalCost - Total cost of grocery items.
 * @param {boolean} options.hideWineCartSheet - Whether the wine sheet is hidden (e.g. auto-dismissed).
 * @param {boolean} options.hideGroceryCartSheet - Whether the grocery sheet is hidden (e.g. auto-dismissed).
 * @param {boolean} options.hideFrozenToast - Whether the frozen fee waive toast is hidden (e.g. auto-dismissed).
 * @param {boolean} options.productAdded - Whether a product has been added to the cart.
 * @param {boolean} options.showOrderMinProgress - Whether the order minimum progress bar should be shown.
 * @param {boolean} options.showFreeShippingProgress - Whether the free shipping progress bar should be shown.
 * @param {boolean} options.showFrozenFeeWaiveToast - Whether the frozen fee waive toast should be shown.
 * @param {number}  options.totalWineBottleQty - Total number of wine bottles in the cart.
 * @returns {{ showWineSheet: boolean, showGrocerySheet: boolean, grocerySheet: { orderMinProgress: boolean, freeShippingProgress: boolean, frozenFeeWaive: boolean } }}
 */
export function getCartSheetVisibility({
    groceryItemsTotalCost,
    hideFrozenToast,
    hideGroceryCartSheet,
    hideWineCartSheet,
    productAdded,
    showFreeShippingProgress,
    showFrozenFeeWaiveToast,
    showOrderMinProgress,
    totalWineBottleQty,
}) {
    const orderMinProgress = showOrderMinProgress && !hideGroceryCartSheet;
    const freeShippingProgress = showFreeShippingProgress && !hideGroceryCartSheet;
    const frozenFeeWaive = showFrozenFeeWaiveToast && !hideFrozenToast;

    const grocerySheetHasContent = orderMinProgress || freeShippingProgress || frozenFeeWaive;

    return {
        showWineSheet: !hideWineCartSheet && totalWineBottleQty > 0 && productAdded,
        showGrocerySheet:
            productAdded &&
            groceryItemsTotalCost > 0 &&
            grocerySheetHasContent &&
            (!hideGroceryCartSheet || frozenFeeWaive),
        grocerySheet: {
            orderMinProgress,
            freeShippingProgress,
            frozenFeeWaive,
        },
    };
}
